import React, { FC } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import useInbox from "hooks/useInbox.ts";
import { useModal } from "contexts/modalContext/modalContext";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import parse from "html-react-parser";
import DownloadLogModal from "components/Reusable/FilesActionGroup/DownloadLogModal";
import { MailDataI } from "models/models";

interface MailDownloadLinkI {
  mailData: MailDataI;
  withText?: boolean;
}

const MailDownloadLink: FC<MailDownloadLinkI> = (props) => {
  const { mailData, withText = true } = props;
  const { setModal } = useModal();
  const { getTextByKey } = useContent();
  const { getSearchParams } = useInbox();

  const openDownloadLogs = () => {
    setModal(() => <DownloadLogModal mailData={mailData} />);
  };

  let logsText = mailData.uniqueDownloadQuantity
    ? `${getTextByKey("mail-unique-downloads-logs-text")} ${
        mailData.uniqueDownloadQuantity
      } <br>`
    : "";
  logsText += `${getTextByKey("mail-total-downloads-logs-text")} ${
    mailData.downloadsQuantity
  }`;

  if (
    (mailData.isOutbox || mailData.isJForm) &&
    mailData.downloadsQuantity > 0
  ) {
    return (
      //@ts-ignore
      <Tooltip
        id={`tooltip-download-log-${mailData.id}`}
        tooltipText={parse(logsText) as unknown as string}
        className="download-log"
        top
      >
        <div className="mail-donwloads log" onClick={openDownloadLogs}>
          {`${mailData.uniqueDownloadQuantity || mailData.downloadsQuantity} ${
            withText ? getTextByKey("inbox-downloads") : ""
          }`}
        </div>
      </Tooltip>
    );
  } else {
    return (
      <div className="mail-donwloads">
        {`${mailData.uniqueDownloadQuantity || mailData.downloadsQuantity} ${
          withText ? getTextByKey("inbox-downloads") : ""
        }`}
      </div>
    );
  }
};

export default MailDownloadLink;
